import { render } from "./Tab2Columns.vue?vue&type=template&id=148750f4"
import script from "./Tab2Columns.vue?vue&type=script&lang=js"
export * from "./Tab2Columns.vue?vue&type=script&lang=js"

import "./Tab2Columns.vue?vue&type=style&index=0&id=148750f4&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__